<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<!-- THIS WHOLE TEMPLATE NEEDS TO BE RE-THOUGHT THROUGH-->
<template>

  <div class="mt-2">

      <vs-collapse accordion type="border" class="mb-2 w-full">

        <vs-collapse-item
          v-for="property in workingProperties"
          :key="property.id">
          <div slot="header">
            {{property.title}} ({{ property.language.name }})
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Title (${property.language.name})`"
                v-model="property.title"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-textarea
                :label="`Body (${property.language.name})`"
                v-model="property.body"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-3/4 w-full mb-2">
              <div class="vx-row">
                <div class="vx-col w-1/2 mb-2">
                  <vs-button v-if="isModified" class="mx-1" @click="saveModifiedProperties">Save Changes</vs-button>
                </div>
                <div class="vx-col w-1/2 mb-2">
                  <vs-button v-if="isModified" type="border" color="warning" @click="revert" class="mx-1">Cancel</vs-button>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/4 w-full mb-2">
              <vs-button class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="deleteProperty(property)"></vs-button>
            </div>
          </div>

        </vs-collapse-item>

      </vs-collapse>

      <vs-button class="ml-auto" color="primary" type="border" icon-after icon="post_add" @click="showAddPropertyDialog">New Property for {{ cyclopedia.name }}</vs-button>


      <vs-prompt
        @accept="createProperty"
        :title="`New Property for ${cyclopedia.name}`"
        :active.sync="showNewPropertyDialog">
        <div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <vs-input
                :label-placeholder="`Title (${language.name})`"
                v-model="addCyclopediaProductPropertyModel.title"
                class="w-full"
              />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-textarea
                :label="`Body (${language.name})`"
                v-model="addCyclopediaProductPropertyModel.body"
                class="w-full"
              />
            </div>
          </div>

        </div>
      </vs-prompt>

  </div>



</template>

<script>
  import types from '@/models';
  import {productHelpers} from '@/models/helpers';
  import api from '@/http/api';

  export default {
    data() {
      return {
        showNewPropertyDialog: false,
        addCyclopediaProductPropertyModel: new types.CyclopediaProductProperty(),
        helpers: productHelpers,
        originalProperties: [ ],
        workingProperties: [ ],
      }
    },
    props: {
      localizedFilteredProperties: {
        type: Array,
        required: true,
        default: () => {
          return [new types.CyclopediaProductProperty()]
        }
      },
      language: {
        type: types.Language,
        required: true,
      },
      cyclopedia: {
        type: types.Cyclopedia,
        required: true,
      },
    },
    watch: {
      localizedFilteredProperties: function (newVal, oldVal) {
        // console.log(JSON.stringify(newVal));
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.originalProperties = JSON.parse(JSON.stringify(newVal));
        this.revert();
      },
      isModified: function (newVal, oldVal) {
        if (newVal === oldVal) return;
        this.$emit('unsavedChangesUpdate', newVal);
      }
    },
    computed: {
      isModified() {
        return JSON.stringify(this.originalProperties) !== JSON.stringify(this.workingProperties);
      },
      productId() {
        return this.$route.query.id || null;
      },
    },
    methods: {
      revert() {
        this.workingProperties = JSON.parse(JSON.stringify(this.originalProperties));
      },
      showAddPropertyDialog() {
        this.addCyclopediaProductPropertyModel = new types.CyclopediaProductProperty({
          product_id: this.productId,
          language_id: this.language.language_id,
          cyclopedia_id: this.cyclopedia.id,
        });
        this.showNewPropertyDialog = true;
      },
      async saveModifiedProperties() {
        let success = false;
        for (let i=0; i<this.workingProperties.length; i++) {
          const originalJson = JSON.stringify(this.originalProperties[i]);
          const workingJson = JSON.stringify(this.workingProperties[i]);
          if (originalJson !== workingJson) {
            success = await this.updateProperty(JSON.parse(workingJson));
            if (!success) break;
          }
        }
        if (success) {
          this.originalProperties = JSON.parse(JSON.stringify(this.workingProperties));
          this.revert();
          this.$emit('productChanged');
        }
      },
      async createProperty() {
        const result = await api.createCyclopediaProductProperty(this.productId, this.addCyclopediaProductPropertyModel);
        const success = result !== null;
        this.showNotification(success, `Property: ${result.title} (${result.id}) ${success ? 'CREATED' : ''}`);
        if (success) {
          result.language = this.language;
          this.originalProperties.push(result);
          this.revert();
          this.$emit('productChanged');
        }
      },
      async updateProperty(property) {
        const toSend = new types.CyclopediaProductProperty(property);
        toSend.product_id = this.productId;
        toSend.cyclopedia_id = this.cyclopedia.id;
        const success = await api.updateCyclopediaProductProperty(this.productId, toSend);
        this.showNotification(success, `Property: ${property.title} (${property.id}) ${success ? 'UPDATED' : ''}`);
        return success;
      },
      async deleteProperty(property) {
        const success = await api.deleteCyclopediaProductProperty(this.productId, property);
        this.showNotification(success, `Property: ${property.title} (${property.id}) ${success ? 'DELETED' : ''}`);
        if (success) {
          this.originalProperties = this.originalProperties.filter((prop) => prop.id !== property.id);
          this.revert();
          this.$emit('productChanged');
        }
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
